export default [
    {
        method: 'getUserInfo',
        type: 'GET',
        path: '/web/user/info',
        mode: 'passport',
        params: ["ct"],
        options: { withCredentials: true, cache: false },
        switch: false
    },
    {
        method: 'userLogout',
        type: 'POST',
        path: '/web/game/login/logout',
        mode: 'passport',
        params: ["ct"],
        options: { withCredentials: true, cache: false },
        switch: false
    },
    {
        method: 'getGameList',
        type: 'GET',
        path: '/game/list',
        mode: 'web',
        params: [],
        options: { cache: false, },
        switch: true
    },
    {
        method: 'getFansList',
        type: 'GET',
        path: '/game/fans_group/list',
        mode: 'web',
        params: [],
        options: { cache: false, },
        switch: true
    },
    {
        method: 'paySwitch',
        type: 'GET',
        path: '/api/web/pay/switch',
        mode: 'pay',
        params: [],
        options: { withCredentials: true, cache: false, },
        switch: true
    },
    {
        method: 'getNavList',
        type: 'GET',
        path: '/home/nav/list',
        mode: 'web',
        params: [],
        options: { cache: false, },
        switch: true
    }
];